import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SizeDataService } from '../../services/size-data.service';
import { createStructSDK } from '@structdk/extension-sdk';

@Component({
  selector: 'app-size-map',
  imports: [FormsModule, CommonModule],
  templateUrl: './size-map.component.html',
  styleUrl: './size-map.component.css',
})
export class SizeMapComponent implements OnInit {
  constructor(private sizeDataService: SizeDataService, private cdr: ChangeDetectorRef) {   
  }

  data: any = null;
  cultureName: string = "da-DK";
  valueHash: string = ""; 
  entityId: string | null = "";
  entityType: string | null = "";
  localModel: { reloadCount: number } = { reloadCount: 5 };

  ngOnInit(): void {
    let qp = new URLSearchParams(window.location.search);
    this.entityId = qp.get("entityid");
    this.entityType = qp.get("entitytype");
    if (this.entityId !== null)
    {
      if (this.entityType !== null && this.entityType.toLowerCase() == "product") {
        this.loadProductData(this.entityId);
      } else if (this.entityType == "variant") {
        this.loadVariantData(this.entityId);
      }
    }
    
    const struct = createStructSDK();
    struct.actions.enableAutoResize({
      maxHeight: 800,    // optional — cap the height
      debounceMs: 200,   // optional — debounce delay (default 100ms)
    });

    setInterval(() => {
        this.checkForChanges();
    }, 5000); 

    setInterval(() => {
        this.countdown();
    }, 1000);
  }

  countdown(): void {
      if (this.localModel.reloadCount > 0) {
          this.localModel.reloadCount--;
          this.cdr.detectChanges();
      }
  }

  resetCountdown(): void {
      this.localModel.reloadCount = 5;
  }

  loadProductData(productId: string): void {
    this.sizeDataService.productSizeTable(productId).subscribe({
      next: (response) => {
        this.data = response;
        this.valueHash = this.data.ValueHash;         
        this.resetCountdown();
      
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Lookup failed', error);
        this.cdr.detectChanges();
      }
    });
  }

  loadVariantData(variantId: string): void {
    this.sizeDataService.variantSizeTable(variantId).subscribe({
      next: (response) => {
        this.data = response;
        this.valueHash = this.data.ValueHash;         
        this.resetCountdown();
      
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Lookup failed', error);
        this.cdr.detectChanges();
      }
    });
  }

  checkForChanges(): void {
    try {
      this.sizeDataService.valueHash(this.entityType!, this.entityId!).subscribe({
        next: (response) => {
          const data = response;
          
          if (data !== this.valueHash) {
              if (this.entityType == "product") {
                  this.loadProductData(this.entityId!)
              } else if (this.entityType == "variant") {
                  this.loadVariantData(this.entityId!)
              }
          } else {
              this.resetCountdown();
          }

          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('ValueHash failed', error);
          this.cdr.detectChanges();
        }
      });      
    } catch (error) {
        console.error('Error checking hash:', error);
    }
  }
}
